<template>
    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        @submit.prevent='SendMessage(model)'
    >
        <v-container >
            <v-row>
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ارسال پیام</h3>
                    <v-select
                        v-model='model.to'
                        :items='contacts'
                        item-text='name'
                        no-data-text='نتیجه‌ای یافت نشد'
                        :loading='loading'
                        :error='error.contact'
                        :error-messages='`${error.contact === true ? "خطا در دریافت اطلاعات از سرور":""}`'
                        return-object
                        filled
                        dense
                        hide-details='auto'
                        label='گیرنده'
                    >
                        <template v-slot:selection='{ item }'>
                            <div class='d-flex align-center py-2'>
                                <v-avatar
                                    size='35'
                                    class='elevation-3'
                                >
                                    <v-img
                                        v-if='item.photo'
                                        :src='`${public_url}/${item.photo}`'
                                        :alt='item.name'
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                                class='fill-height ma-0'
                                                align='center'
                                                justify='center'
                                            >
                                                <v-progress-circular
                                                    indeterminate
                                                    color='grey lighten-5'
                                                ></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                    <p v-else class='text--disabled mb-0'>{{ item.name.slice(0, 2) }}</p>
                                </v-avatar>
                                <div class='mr-2'>
                                    <p class='mb-0 text-caption rtl sm-line-height'>{{ item.name }}</p>
                                    <p class='mb-0 text-caption sm-line-height'>{{ item.phone }}</p>
                                </div>

                            </div>
                        </template>
                        <template v-slot:item='{ active, item, attrs, on }'>
                            <v-list-item v-on='on' v-bind='attrs' #default=''>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <div class='d-flex align-center py-1'>
                                            <v-avatar
                                                size='35'
                                                class='elevation-3'
                                            >
                                                <v-img
                                                    v-if='item.photo'
                                                    :src='`${public_url}/${item.photo}`'
                                                    :alt='item.name'
                                                >
                                                    <template v-slot:placeholder>
                                                        <v-row
                                                            class='fill-height ma-0'
                                                            align='center'
                                                            justify='center'
                                                        >
                                                            <v-progress-circular
                                                                indeterminate
                                                                color='grey lighten-5'
                                                            ></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                                <p v-else class='text--disabled mb-0'>{{ item.name.slice(0, 2) }}</p>
                                            </v-avatar>
                                            <div class='mr-2'>
                                                <p class='mb-0 text-caption rtl sm-line-height'>{{ item.name }}</p>
                                                <p class='mb-0 text-caption sm-line-height'>{{ item.phone }}</p>
                                            </div>
                                        </div>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                        v-model='model.text'
                        :rules='rules.text'
                        required
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>متن پیام
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-btn
                        block
                        name='submit'
                        :disabled='!valid || !model.to._id'
                        color='primary'
                        :loading='loading'
                        type='submit'
                        @click='validate'
                    >ارسال
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'NewMessage',
        data: () => ({
            loading: true,
            error: {
                contact: false
            },
            valid: true,
            contacts: [],
            model: {
                to: {},
                text: ''
            },
            rules: {
                text: [
                    v => !!v || 'متن پیام اجباری میباشد'
                ]
            }
        }),
        methods: {
            validate() {
                this.showNavigationBar();
                this.$refs.form.validate();
            },
            async SendMessage(data) {
                this.loading = true;
                await axios.post('/api/messages/', {
                    text: data.text, to: data.to._id
                })
                    .then(response => {
                        let message = 'پیام شما با موفقیت ارسال شد.';
                        this.loading = false;
                        this.$snackbar.showMessage({ content: message, color: 'success' });
//                        todo Force: check store.state.history to remove redirection
                        this.$router.push({
                            name: 'Message',
                            params: { messageThread_id: response.data.messageThread._id }
                        });
                    }).catch(() => {
                        let message = 'خطا در ارسال پیام';
                        this.$snackbar.showMessage({ content: message, color: 'warning' });
                        this.loading = false;
                    });
            },
            hideNavigationBar() {
                this.showNavigation(false);
            },
            showNavigationBar() {
                this.showNavigation(true);
            },
            ...mapActions(['showNavigation', 'showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.loading = true;
            await axios
                .get('/api/messages/contacts')
                .then(response => {
                    this.error.contact = false;
                    this.contacts = response.data.contacts;

                }).catch(() => {
                    this.error.contact = true;

                });
            if (this.$route.params.user_id) {
                this.model.to = this.contacts.filter(item => item._id === this.$route.params.user_id)[0];
            }
            await this.setBreadCrumbsTemp({
                key: 'messages',
                value: {
                    text: `پیام ها`,
                    href: '/Messages'
                }
            });
            let href = window.location.pathname + window.location.search;

            await this.setBreadCrumbsTemp({
                key: 'newMessages',
                value: {
                    text: `ارسال پیام`,
                    href
                }
            });

            this.loading = false;
        },
        async updated() {
            await this.showBreadCrumbs([ 'messages', 'newMessages']);
        },
        computed: {
            ...mapState(['public_url'])
        }
    };
</script>